export default __webpack_public_path__ + "static/l8-portfolio-img-5-2a0e02c60ed2c424f22c812124a7685b.jpg";